"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const ProfileHeadline_module_scss_1 = __importDefault(require("./ProfileHeadline.module.scss"));
function ProfileHeadline({ user, closeHandler, activeBlock, errorState }) {
    if (user) {
        return (react_1.default.createElement("div", { className: ProfileHeadline_module_scss_1.default.headline },
            react_1.default.createElement("div", { className: ProfileHeadline_module_scss_1.default.title },
                `Hello, ${user === null || user === void 0 ? void 0 : user.firstName}!`,
                " ",
                react_1.default.createElement("div", { className: ProfileHeadline_module_scss_1.default.email }, user === null || user === void 0 ? void 0 : user.email),
                (errorState === null || errorState === void 0 ? void 0 : errorState.status) === 'failed' ? react_1.default.createElement("div", { className: ProfileHeadline_module_scss_1.default.error }, errorState === null || errorState === void 0 ? void 0 : errorState.message) : null),
            activeBlock,
            react_1.default.createElement(CloseButton_1.default, { onCLickHandler: closeHandler })));
    }
    return null;
}
exports.default = ProfileHeadline;
